var map = {
	"./directives/templates/purchaseWarningModal.html": 48,
	"./directives/templates/robuxContainer.html": 49,
	"./directives/templates/robuxContainerBase.html": 50,
	"./directives/templates/robuxContainerCnb.html": 51,
	"./directives/templates/robuxPackage.html": 52,
	"./directives/templates/robuxPackageCnb.html": 53,
	"./directives/templates/robuxSubscriptionUpsellContainer.html": 54,
	"./directives/templates/robuxSubscriptionUpsellPackage.html": 55
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 47;